<div class="container">

  <!-- ======================= MOBILE VIEW ======================= -->
  @if (isMobile$ | async) {
  <div class="mobile">
    <!-- Header (Hidden on Desktop) -->
    <div class="vehicle-wrapper">
      <div class="vehicle-header">
        <p-button
          label=""
          icon="pi pi-chevron-left"
          iconPos="left"
          class="back-button"
          (onClick)="onBack()">
        </p-button>

        <div class="vehicle-title">
          {{ (vehicleName$ | async) ?? 'Vehicle' }}
        </div>
      </div>
    </div>

    <div class="content">
      @if (!showDetailsMobile) {
        <!-- Top Bar -->
        <div class="vehicle-context">
          <p>Vehicle <strong>{{ vehicleName$ | async }}</strong> has the following restrictions:</p>
        </div>

        <!-- Search Section (Hidden on Desktop) -->
        <div class="search-container">
          <div class="search-input">
            <input
              type="text"
              pInputText
              placeholder="Search restriction"
              [formControl]="searchTermControl"
            />
          </div>
        </div>

        <!-- Vehicle Restrictions Section (Hidden on Desktop) -->
        @if (restrictions$ | async; as restrictions) {
          <div class="card-list">
            @for (r of filteredRestrictions$ | async; track r.restrictionName) {
              <p-card
                class="restriction-card clickable"
                role="button"
                tabindex="0"
                (click)="onSelectMobile(r, restrictions)"
              >
                <div class="card-row">
                  <span class="label">{{ r.restrictionName }}</span>
                  <i class="pi pi-chevron-right chevron" aria-hidden="true"></i>
                </div>
                @if (r.banPublicRoad) {
                  <div class="subheader">
                    <img src="assets/icons/banPublicRoad.png" alt="Public Road" class="icon" width="24" height="24" /> Banned for Public Road 
                  </div>
                }
                @if (r.banTestTrack) {
                  <div class="subheader">
                    <img src="assets/icons/banTestTrack.png" alt="Test Track" class="icon" width="24" height="24" /> Banned for Test Track 
                  </div> 
                }
                @if (!r.banPublicRoad && !r.banTestTrack) {
                  <div class="subheader"> Restricted with no bans </div>
                }
              </p-card>
            }
          </div>
        }
      } @else {
        <!-- TODO: Add user roles so that not all users can edit from their phone -->
        <!-- <div class="edit-restriction-button">
          <button
            pButton
            type="button"
            label="Edit Restriction"
            icon="pi pi-pencil"
            (click)="onEditSelected()"
            class="grow-button">
          </button>
        </div> 
        <app-restriction-dialog
          [(visible)]="showEditDialog"
          [editRestriction]="currentRestriction$ | async"
          (onSave)="onDialogSave($event)">
        </app-restriction-dialog> -->
        <app-restriction-details 
          [restricion]="selectedRestrictionMobile"
          (close)="onCloseDetails()">
        </app-restriction-details>
      }
    </div>
  </div><!-- .mobile -->
  } @else {
  <!-- ======================= DESKTOP VIEW ======================= -->
  <div class="desktop">
    <app-main-header></app-main-header>
    <div class="content">
      <!-- Top Bar -->
      <div class="top-bar">
        <div class="vehicle-context">
          <p>For the vehicle <strong>{{ vehicleName$ | async }}</strong> the following restrictions apply:</p>
        </div>
        @if (isAdmin$ | async) {
          <div class="edit-restriction-button">
            <button
              pButton
              type="button"
              label="Edit Restriction"
              icon="pi pi-pencil"
              (click)="onEditSelected()">
            </button>
          </div>
        }
      </div>

      @if (restrictions$ | async; as restrictions) {
        <div class="restrictions-grid">
          <div class="left-column">
            <p-listbox
              class="restrictions-nav p-listbox--sticky"
              [options]="restrictions"
              [(ngModel)]="selectedRestriction"
              [metaKeySelection]="true"
              optionLabel="restrictionName"
              [filter]="true"
              filterPlaceholder="Search…"
              [listStyle]="{ 'max-height':  'none', 'height': 'auto' }"  
              (onChange)="selectedIndex = restrictions.indexOf(selectedRestriction!)">

              <ng-template pTemplate="item" let-r>
                <div class="nav-row">
                  <span class="label">{{ r.restrictionName }}</span>
                  <i class="pi pi-chevron-right chevron" aria-hidden="true"></i>
                </div>
              </ng-template>
            </p-listbox>
          </div>
          <div class="restrictions-panels">
            <app-restriction-details [restricion]="restrictions[selectedIndex]"></app-restriction-details>
          </div>
        </div>
      }

      <app-restriction-dialog
        [(visible)]="showEditDialog"
        [editRestriction]="editingRestriction"
        (onSave)="onDialogSave($event)">
      </app-restriction-dialog>
    </div>
  </div><!-- .desktop -->
  }
</div><!-- .container -->